import React, {
  forwardRef,
  useCallback,
  useEffect,
  useState,
  useRef,
} from "react";
import { useController, useFormContext } from "react-hook-form";

import { StyledWrapper } from "./imageFileField.style";

import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";

const ImageFileField = forwardRef(
  ({ name, required, acceptExtensions, image_url }, ref) => {
    const {
      field,
      fieldState: { error },
    } = useController({ name });
    const { getValues } = useFormContext();
    const serverPic = image_url && getValues(image_url);
    const [files, setFiles] = useState(field.value || undefined);
    const imgRef = useRef(null);

    const handleFileChanged = useCallback(
      (file) => {
        if (!file) return;
        if (files?.name === file.name)
          return alert("That file is already uploaded");
        setFiles(file);
      },
      [name, files],
    );

    useEffect(() => {
      field.onChange(files);
      if (files) {
        imgRef.current.src = URL.createObjectURL(files);
      }
    }, [files]);

    return (
      <StyledWrapper ref={ref} $showImg={serverPic || files}>
        <div>
          <img ref={imgRef} src={serverPic} alt="img" />
        </div>
        <GenericInputField
          type={TYPES.FILE}
          name={name}
          required={required}
          error={error}
          handleChange={handleFileChanged}
          accept={acceptExtensions}
          bottomMessage="We accept .png, .jpg, .jpeg formats up to to 10 megabytes"
          dropAreaText="Drag and drop the logo here"
        />
      </StyledWrapper>
    );
  },
);
ImageFileField.displayName = "ImageFileField";

export default ImageFileField;
